"use strict";

exports.__esModule = true;
exports.TimeCellType = exports.CELL_TYPE = void 0;
var _timeType = require("./timeType");
exports.CELL_TYPE = _timeType.CELL_TYPE;
exports.TimeCellType = _timeType.TimeCellType;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/cellTypes/timeType/index.js
// module id = 1118
// module chunks = 0